import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import PublicHeader from '../../components/public/PublicHeader';
import PublicFooter from '../../components/public/PublicFooter';
import FaqAccordion from '../../components/public/FaqAccordion';
import { CONTACT } from '../../config/contact';

const FAQ = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 font-sans selection:bg-teal-500/30 animate-pageFadeIn">
    <PublicHeader />

    <div className="relative pt-24 sm:pt-28 lg:pt-32 pb-16 overflow-hidden">
      {/* Ambient background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_0%,_var(--tw-gradient-stops))] from-teal-100/60 via-transparent to-transparent dark:from-teal-900/20 pointer-events-none" />
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-teal-200/30 dark:bg-teal-800/20 blur-3xl pointer-events-none" aria-hidden="true" />
      <div className="absolute top-10 -right-24 w-72 h-72 rounded-full bg-cyan-200/30 dark:bg-cyan-800/20 blur-3xl pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-[1760px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page header */}
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white dark:bg-gray-800 border border-gray-200/70 dark:border-gray-700 text-teal-600 dark:text-teal-400 text-xs font-bold uppercase tracking-wider shadow-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-teal-500 animate-pulse" />
            Frequently Asked Questions
          </span>
          <h1 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-gray-900 dark:text-white">
            Everything you need to know about{' '}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-cyan-500">Ospito+ HMS</span>
          </h1>
          <div className="mx-auto mt-4 h-1.5 w-24 rounded-full bg-gradient-to-r from-teal-500 to-cyan-500 shadow-lg shadow-teal-500/30" />
          <p className="mx-auto mt-5 max-w-2xl text-sm sm:text-base leading-relaxed text-gray-600 dark:text-gray-400">
            Answers on getting started, clinical workflows, pharmacy and stock control, security, backups, and pricing.
            If your question is not covered here, our team is a message away.
          </p>
        </div>

        {/* FAQ content — items flow directly on the page background */}
        <FaqAccordion columnCount={3} />

        {/* Footer CTA */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-sm font-bold shadow-lg shadow-teal-500/25 hover:scale-[1.03] transition-transform"
          >
            View pricing
            <ArrowRightIcon className="w-4 h-4" />
          </Link>
          <a
            href={CONTACT.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:border-teal-300 dark:hover:border-teal-700 transition-colors"
          >
            Talk to us
          </a>
        </div>
      </div>
    </div>

    <PublicFooter />
  </div>
);

export default FAQ;
